import { Alert, Button, Modal } from 'react-bootstrap'

interface IProps {
    show: boolean,
    fullName: string,
    isCystatinC: boolean,
    onConfirm: () => void,
    onCancel: () => void
}

const RestartPwlModal = (props: IProps) => {
    return (
        <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>
                {props.isCystatinC ? 'Restart PWL (Cystatin C)' : 'Restart PWL'}
            </Modal.Header>
            <Modal.Body>
                <div style={{ marginBottom: 20, textAlign: 'center' }}>
                    Confirm that you want to restart PWL for donor <strong>{props.fullName}</strong>...
                </div>

                <Alert bsStyle='warning'>
                    By restarting the PWL you will lose the links to all previous information and the
                    pre-workup lab counts will not match up with how many PWL we actually implemented..
                </Alert>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={props.onConfirm}>Confirm</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default RestartPwlModal;